<script>
import cloneDeep from 'lodash/cloneDeep'
import tourMixin from '@src/mixins/tour'
import { authComputed } from '@state/helpers'
import lazyLoadComponent from '@router/lazyload-component'
import { cities as TaiwanCity } from '@utils/taiwan-city-area'
import { taiwanCitys } from '@utils/filter-value-to-text'

const minutesOfTime = (time = '00:00') => {
  const timeMatches = time.match(/^(\d+):(\d+)$/i)
  const [, hours, minutes] = timeMatches
  return Number(hours) * 60 + Number(minutes)
}

const initData = () => {
  return {
    state: 2,
    hidden: 0,
    name: '',
    alias: '',
    type: '',
    description: '',
    notice: '',
    location: {
      name: '',
      country: '臺灣',
      city: '',
      address: '',
    },
    staffs: [],
    introimage: '',
    image: '',
    video: '',
    orderExtrafields: [],
    allowOverlap: 0,
    params: {
      addressRestrictions: [
        {
          city: '',
          region: [],
        },
      ],
      serviceTimeSetting: {
        start: '',
        end: '',
        lastOrder: '',
        beforehandOrder: 0,
      },
    },
  }
}
export default {
  components: {
    BaseInputFloatingLabel: () => lazyLoadComponent(import('@components/BaseInputFloatingLabel')),
    ServiceAreaItem: () => lazyLoadComponent(import('./ServiceAreaItem')),
    // BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
  },
  mixins: [tourMixin],
  tourName: 'productBasic',
  props: {
    itemType: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      taiwanCitys,
      sameAsMerchant: true,
      merchantInfo: {},
      TaiwanCityList: Object.freeze(TaiwanCity),
      submitData: cloneDeep(Object.assign({}, initData(), this.defaultValue)),
      submitRules: {
        name: [
          {
            required: true,
            message: '請填寫名稱',
            trigger: 'blur',
          },
        ],
        // alias: [
        //   {
        //     required: true,
        //     message: '請填寫別名',
        //     trigger: 'blur',
        //   },
        //   {
        //     pattern: /^[a-zA-Z0-9-]+$/,
        //     message: '請使用英文大小寫字母、數字或英文半形連字號組合',
        //     trigger: 'blur',
        //   },
        // ],
        description: [
          {
            required: true,
            message: '請填寫描述',
            trigger: 'blur',
          },
        ],
        'location.name': [
          {
            required: true,
            message: '請填寫地點名稱',
            trigger: 'blur',
          },
        ],
        // 'location.country': [
        //   {
        //     required: true,
        //     message: '請選擇國家',
        //     trigger: 'change',
        //   },
        // ],
        'location.city': [
          {
            required: true,
            message: '請選擇城市',
            trigger: 'change',
          },
        ],
        'location.address': [
          {
            required: true,
            message: '請輸入地址',
            trigger: 'blur',
          },
        ],
        // video: [
        //   {
        //     pattern: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/,
        //     message: '請輸入有效的 YouTube 影片網址',
        //     trigger: 'blur',
        //   },
        // ],
        'params.addressRestrictions.city': [
          {
            required: true,
            message: '請選擇城市',
            trigger: 'blur',
          },
        ],
        'params.addressRestrictions.region': [
          {
            required: true,
            message: '請選擇區域',
            trigger: 'blur',
          },
        ],
        'params.serviceTimeSetting.start': [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請選擇營業開始時間'))
              if (this.submitData.params.serviceTimeSetting.end) this.$refs.form.validateField('params.serviceTimeSetting.end')

              callback()
            },
            trigger: 'change',
          },
        ],
        'params.serviceTimeSetting.end': [
          {
            required: true,
            validator: (rule, value, callback) => {
              const { start } = this.submitData.params.serviceTimeSetting
              if (minutesOfTime(start) >= minutesOfTime(value)) return callback(new Error('結束時間不可早於開始時間'))
              callback()
            },
            trigger: 'change',
          },
        ],
        'params.serviceTimeSetting.lastOrder': [
          {
            required: true,
            message: '請選擇時間',
            trigger: 'change',
          },
        ],
        'params.serviceTimeSetting.beforehandOrder': [
          {
            required: true,
            message: '請輸入提前預約時間',
          },
        ],
      },
    }
  },
  computed: {
    ...authComputed,
    productBaseBookingUrl() {
      return `${this.merchantUrl}/product/`
    },
    isEditMode() {
      return this.defaultValue.id
    },
    filteredCity() {
      const selectedCitys = this.submitData.params.addressRestrictions.map((res) => res.city)
      return taiwanCitys.filter((city) => {
        return !selectedCitys.includes(city.name)
      })
    },
  },
  created() {
    !this.isEditMode || (this.isEditMode && !this.submitData.orderExtrafields.byProduct)
      ? this.requestExtraFieldbyProduct()
      : this.updateExtraFieldbyProduct(this.submitData.orderExtrafields.byProduct)
    !this.isEditMode && this.tryToFetchMerchant()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    async requestExtraFieldbyProduct() {
      const extraFieldData = await this.$store.dispatch('product/fetchExtraField', {
        typeByProduct: this.itemType,
      })
      const filterData = extraFieldData.map((field) => {
        const { id, title, value, required } = field
        return {
          id,
          title,
          value,
          required,
        }
      })
      this.updateExtraFieldbyProduct([...filterData])
    },
    updateExtraFieldbyProduct(value) {
      this.submitData.orderExtrafields = value
    },
    async tryToFetchMerchant() {
      const data = await this.$store.dispatch('merchant/fetchSingle')
      this.merchantInfo = { ...data }
      this.submitData.location.name = data.name
      this.submitData.location.city = data.city
      this.submitData.location.address = data.address
    },
    onChange(checked) {
      if (checked) {
        this.submitData.location.name = this.merchantInfo.name
        this.submitData.location.city = this.merchantInfo.city
        this.submitData.location.address = this.merchantInfo.address
      } else {
        this.submitData.location.name = ''
        this.submitData.location.city = ''
        this.submitData.location.address = ''
      }
    },
    onRemoveServiceArea(index) {
      this.submitData.params.addressRestrictions.splice(index, 1)
    },
    onAddServiceArea() {
      this.submitData.params.addressRestrictions.push({
        city: '',
        region: [],
      })
    },
  },
}
</script>

<template>
  <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating">
    <template v-if="isEditMode">
      <h4 class="form-block-title">{{
        $t('PRODUCT.TITLE_STATE_AND_DISPLAY', {
          name: $t(`PRODUCT.${itemType}.NAME`),
        })
      }}</h4>
      <el-row>
        <el-col :span="12">
          <el-form-item
            :label="
              $t('PRODUCT.STATE_LABEL', {
                name: $t(`PRODUCT.${itemType}.NAME`),
              })
            "
            prop="state"
          >
            <el-switch v-model="submitData.state" active-text="開放" inactive-text="關閉" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col v-if="submitData.state === 1" :span="12">
          <el-form-item label="在商店首頁" prop="hidden">
            <el-switch v-model="submitData.hidden" active-text="顯示" :active-value="0" inactive-text="隱藏" :inactive-value="1"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <h4 data-tour-text="介紹你的活動吧！讓客戶初步了解活動內容及更多注意事項。" class="form-block-title">基本資訊</h4>
    <el-form-item :label="$t('PRODUCT.NAME_LABEL', { name: $t(`PRODUCT.${itemType}.NAME`) })" prop="name">
      <BaseInputFloatingLabel v-model="submitData.name" />
    </el-form-item>
    <!-- <el-form-item
      :label="
        $t('PRODUCT.ALIAS_LABEL', { name: $t(`PRODUCT.${itemType}.NAME`) })
      "
      prop="alias"
    >
      <BaseInputFloatingLabel
        v-model="submitData.alias"
        placeholder="請使用英文字母與數字組合"
      >
        <template v-slot:prepend>{{ productBaseBookingUrl }}</template>
      </BaseInputFloatingLabel>
    </el-form-item> -->
    <el-form-item
      :label="
        $t('PRODUCT.DESCRIPTION_LABEL', {
          name: $t(`PRODUCT.${itemType}.NAME`),
        })
      "
      prop="description"
    >
      <BaseInputFloatingLabel v-model="submitData.description" type="textarea" :autosize="{ minRows: 2 }" />
    </el-form-item>
    <!-- <el-row v-if="!isEditMode">
      <el-col :span="8">
        <el-form-item
          :label="
            $t('PRODUCT.OVERLAP_LABEL', {
              name: $t(`PRODUCT.${itemType}.NAME`),
            })
          "
          prop="allowOverlap"
        >
          <el-switch
            v-model="submitData.allowOverlap"
            active-text="是"
            inactive-text="否"
            :active-value="0"
            :inactive-value="1"
          ></el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-alert
          title="若您的預訂是一個時段結束後再接續另一場時段者，請開啟此選項以避免施作人員分身乏術。"
          :closable="false"
          type="warning"
          effect="dark"
        ></el-alert>
      </el-col>
    </el-row> -->

    <el-form-item label="注意事項" prop="notice">
      <BaseInputFloatingLabel v-model="submitData.notice" type="textarea" :autosize="{ minRows: 2 }" />
    </el-form-item>
    <!-- <template v-if="submitData.orderExtrafields instanceof Array">
      <el-form-item
        v-for="(extrafield, fieldIndex) in submitData.orderExtrafields"
        :key="fieldIndex"
        :label="extrafield.title"
        :prop="`orderExtrafields.${fieldIndex}.value`"
        :rules="{
          required: !!extrafield.required,
          message: `請填寫${extrafield.title}`,
        }"
      >
        <BaseInputFloatingLabel
          v-model="extrafield.value"
          type="textarea"
          :autosize="{ minRows: 2 }"
        />
      </el-form-item>
    </template> -->

    <h4 class="form-block-title">地點</h4>
    <el-form-item v-if="!isEditMode">
      <el-checkbox v-model="sameAsMerchant" style="width:100%;" label="同商家地址" border @change="onChange"></el-checkbox>
    </el-form-item>
    <el-form-item label="名稱" prop="location.name">
      <BaseInputFloatingLabel v-model="submitData.location.name" />
    </el-form-item>
    <!-- <el-form-item label="國家" prop="location.country">
      <el-select v-model="submitData.location.country">
        <el-option label="臺灣" value="臺灣"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="城市" prop="location.city">
      <el-select v-model="submitData.location.city">
        <el-option v-for="city in TaiwanCityList" :key="city.CityName" :label="city.CityName" :value="city.CityName"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="地址" prop="location.address">
      <BaseInputFloatingLabel v-model="submitData.location.address" />
    </el-form-item>

    <!-- <h4
      data-tour-text="你的活動有大卡司嗎？建立你的活動嘉賓吸引客戶的注意吧！"
      class="form-block-title form-block-title--small-margin"
      >人員</h4
    >
    <StaffList v-model="submitData.staffs" /> -->

    <template v-if="defaultValue.name === '到府服務'">
      <h4 class="form-block-title">服務區域</h4>
      <ServiceAreaItem
        v-for="(restriction, index) in submitData.params.addressRestrictions"
        :key="`restriction-${index}`"
        :item-index="index"
        :default-value="restriction"
        :citys="filteredCity"
        :show-remove="submitData.params.addressRestrictions.length > 1"
        @remove="onRemoveServiceArea"
      ></ServiceAreaItem>
      <el-button
        type="primary"
        class="is-round is-border is-fullwidth"
        style="margin-top: 30px;"
        plain
        :disabled="taiwanCitys.length === submitData.params.addressRestrictions.length"
        @click="onAddServiceArea"
        ><BaseIcon name="plus"></BaseIcon> 新增服務區域{{ taiwanCitys.length === submitData.params.addressRestrictions.length ? '（已選擇全部區域）' : '' }}</el-button
      >
    </template>

    <h4 class="form-block-title">服務時間設定</h4>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item class="el-form-item--normal-margin" label="開始營業時間" prop="params.serviceTimeSetting.start">
          <el-time-picker v-model="submitData.params.serviceTimeSetting.start" format="HH:mm" value-format="HH:mm" placeholder="選擇開始營業時間" :clearable="false"></el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="el-form-item--normal-margin" label="結束營業時間" prop="params.serviceTimeSetting.end">
          <el-time-picker v-model="submitData.params.serviceTimeSetting.end" format="HH:mm" value-format="HH:mm" placeholder="選擇結束營業時間" :clearable="false"></el-time-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="24">
        <el-form-item class="el-form-item--normal-margin" label="最晚接受預約時間" prop="params.serviceTimeSetting.lastOrder">
          <el-time-picker v-model="submitData.params.serviceTimeSetting.lastOrder" format="HH:mm" value-format="HH:mm" placeholder="選擇最晚接受預約時間" :clearable="false"></el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item class="el-form-item--normal-margin" label="提前預約時間" prop="params.serviceTimeSetting.beforehandOrder">
          <BaseInputFloatingLabel v-model.number="submitData.params.serviceTimeSetting.beforehandOrder" min="0">
            <template v-slot:append
              >分鐘</template
            >
          </BaseInputFloatingLabel>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- <h4 data-tour-text="上傳活動或環境照片吸引客戶的目光吧！" class="form-block-title">圖片</h4>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="目錄縮圖" prop="introimage">
          <BaseUpload v-model="submitData.introimage" resource="product" suggest-size="640/480" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="介紹橫幅形象圖" prop="image">
          <BaseUpload
            v-model="submitData.image"
            resource="product"
            suggest-size="912/300"
          />
        </el-form-item>
      </el-col>
    </el-row> -->

    <!-- <h4
      data-tour-text="有任何精彩的影片也不錯過！立刻輸入影片網址讓客戶看看吧！"
      class="form-block-title"
      >影片</h4
    >
    <el-form-item label="YouTube 影片網址" prop="video">
      <BaseInputFloatingLabel v-model="submitData.video" />
    </el-form-item> -->
  </el-form>
</template>
